import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import SwitchBtns from 'modules/Common/components/SwitchBtns';
import Tabs from 'modules/Common/components/Tabs';
import HorseRacingAbcTable from 'modules/HorseRacing/components/HorseRacingAbcTable';
import HorseRacingPersonAbcTable from 'modules/HorseRacing/components/HorseRacingPersonAbcTable';
import { momentInUTC, isoDate } from 'utils/LocalDateTimeHelper';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import { metaDescription, canonicalLink } from 'utils/seoUtils';

import { load, isLoaded } from '../reducers/abc';

const defaultLetterRange = 'A-D';

function apiParams({days, letterRange}) {
    let letterRangeParam;

    let start = momentInUTC(), end = start;
    if (days == 'tomorrow') {
      start = momentInUTC().add('1', 'day');
      end = start;
    } else if (days == '5-days') {
      end = momentInUTC().add('5', 'day');
      letterRangeParam = letterRange ? letterRange.toUpperCase() : defaultLetterRange;
    }

    return [isoDate(start), isoDate(end), "UK,IRE", letterRangeParam];
}

@standardAsyncConnect([
  {
    dispatch: ({params}) => load(...apiParams(params)),
    preventResolve:({state, params}) => isLoaded(state, ...apiParams(params)),
    state: state => ({races: state.horseRacing.abc.races})
  },
  userServiceLayoutConnect()
])
@catchLifeCycleErrors
export default class HorseRacingAbcGuide extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    races: PropTypes.array,
    params: PropTypes.object
  };

  render() {
    const {
      routes,
      races,
      params: {
        days: selectedDays = 'today',
        type: groupingBy = 'horses',
        letterRange = defaultLetterRange
      }
    } = this.props;

    require('./HorseRacingAbcGuide.scss');

    if (!races) {
      return (
        <div className="hr-racing-racecards">
          <p className="hr-racing-racecards-error-message">ABC Guide is currently unavailable. Please check back later.</p>
        </div>
      );
    }

    const todayTabs = [{
      href: '/racing/abc-guide',
      text: 'Declared Runners',
      isIndex: true
    },
    { href: '/racing/abc-guide/today/jockeys',
      text: 'Jockey Rides'
    },
    { href: '/racing/abc-guide/today/trainers',
      text: 'Trainer Entries'
    }];

    const letterRangeTabs = [{
      href: '/racing/abc-guide/5-days',
      text: 'A-D',
      isIndex: true
    },{
      href: '/racing/abc-guide/5-days/horses/e-l',
      text: 'E-L'
    },{
      href: '/racing/abc-guide/5-days/horses/m-r',
      text: 'M-R'
    },{
      href: '/racing/abc-guide/5-days/horses/s-z',
      text: 'S-Z'
    }];

    let rides = [];

    races.map(race => {
      race.rides.map(ride => {
        rides.push({race, ride});
      });
    });

    let pageTitle = 'ABC Guide';
    let metaDescriptionDayText;
    if (selectedDays == 'today') {
      pageTitle = `Today's ABC Guide of ${groupingBy}`;
      metaDescriptionDayText = "today's";
    }
    else if (selectedDays == 'tomorrow') {
      pageTitle = `Tomorrow's ABC Guide of ${groupingBy}`;
      metaDescriptionDayText = "tomorrow's";
    }
    else {
      pageTitle = `Five Day ABC Guide (${letterRange.toUpperCase()})`;
      metaDescriptionDayText = "the next five days'";
    }

    const helmetProps = {
      title: pageTitle,
      ...metaDescription(`All of ${metaDescriptionDayText} declared ${groupingBy} and where they’re running, listed in alphabetical order on Sporting Life and complete with Sky Bet odds.`),
      ...canonicalLink(routes, {days: selectedDays, type: groupingBy, letterRange})
    };

    return (
      <div className="horse-racing-abc-guide">
        <MetaDataWrapper helmetProps={helmetProps}/>
        <h1 className="page-main-title">ABC Guide</h1>
        <SwitchBtns buttonCount="3" buttons={[
          {href: '/racing/abc-guide',  text: 'Today', isIndex: true, alternatives: [{href: '/racing/abc-guide/today/jockeys'}, {href: 'racing/abc-guide/today/trainers'}]},
          {href: '/racing/abc-guide/tomorrow', text: 'Tomorrow'},
          {href: '/racing/abc-guide/5-days', text: '5 Days'}
        ]}/>
        <section className="horse-racing-abc-guide-content">
          {selectedDays == 'today' && <Tabs tabs={todayTabs} centerDefault/>}
          {selectedDays == '5-days' && <Tabs tabs={letterRangeTabs} centerDefault/>}
          {groupingBy == 'horses' ?
            <HorseRacingAbcTable rides={rides} days={selectedDays}/> :
            <HorseRacingPersonAbcTable rides={rides} tableType={groupingBy}/>}
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingAbcGuide.js